import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "react";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { formatVehicleTitle, formatVehicleDescription, ...props } = useMergedConstructorItemProps(
    item,
    GET_DEFAULT_CONTAINER_PROPS
  );
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const title = vehicleItem ? formatVehicleTitle(vehicleItem) : null;
  const description = vehicleItem ? formatVehicleDescription(vehicleItem) : null;
  return {
    ...props,
    title,
    description,
    isLoading
  };
};
export {
  useContainer
};
